module.exports = __webpack_public_path__ + "static/media/2 Train-AP_Z2.04a342d3.png";